import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.ash,
  tileBgColor: colors.white,
  iconBgColor: colors.ash
};
export default imageGallery;